export default{
    matchemail (v) {
        let mailForm = /^(\w+.?)+@(\w+.?)+\.\w+$/
        if (v.match(mailForm)) {
          return true
        } return false
      }
}